import { render } from "./index.vue?vue&type=template&id=12a22a1d"
import script from "./league.ts?vue&type=script&lang=js"
export * from "./league.ts?vue&type=script&lang=js"

import "./league.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script